module.exports = "<svg viewBox=\"0 0 32 32\" fill=\"black\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.25 6.46997V27.36C5.25 27.91 5.7 28.36 6.25 28.36H25.85C26.2 28.36 26.5 28.17 26.68 27.89L5.25 6.46997Z\"></path><path d=\"M26.8504 24.3V5.35999C26.8504 4.80999 26.4004 4.35999 25.8504 4.35999H6.90039L26.8504 24.3Z\"></path><path d=\"M0.219727 5.12999L26.9097 31.81L28.7897 29.93L2.09973 3.23999L0.219727 5.12999Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./src/assets/fin-contrat.svg
// module id = kGB2
// module chunks = 2